// src/pages/Article.js
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';

function Article() {
    const [articleData, setArticleData] = useState(null);
    const [noArticleData, setNoArticleData] = useState(null);
    const { id } = useParams();

    useEffect(() => {        
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getArticles/${id}`)
        .then((response) => {
            setArticleData(response.data);
            console.log(response.data)
        })
        .catch((error) => {
            setNoArticleData(error.response.data);
            console.error("There was an error fetching the data!", error);
        });
    }, []);

    if (!articleData) {
        if (noArticleData)
            return (<div className="page-content">
                <h2>標竿刊物</h2>
                <p className='error'>
                    抱歉，標竿刊物編號：{id}並不存在。
                </p>
                <Link to="/testimonies">
                    <button className='button button-m'>
                        返回【標竿刊物】
                    </button>
                </Link>
            </div>)
        return <div>加載中 Loading...</div>;
    }

  return (
    <div className="page-content">
        <h2>標竿刊物</h2>
        <h1>
            {articleData.title}
        </h1>
        <h4>{new Date(articleData.date).toLocaleDateString()} - {articleData.name}</h4>
        <div dangerouslySetInnerHTML={{ __html: articleData.content }} />
    </div>
  );
}

export default Article;